import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import Translation from '../../../lang/Translation';
import Spacing from '../../../style-helper/Spacing';

const useStyles = createUseStyles({
  defaultAddressSection: {
    marginTop: 0,
    display: 'flex',
    padding: 0,
    borderTop: '1px solid #ccc',
  },
  defaultAddressIcon: {
    marginTop: 5,
    marginLeft: 5,
    paddingBottom: 0,
  },
  defaultAddressText: {
    marginTop: Spacing.single,
    marginLeft: Spacing.double,
  },
});

function DefaultAddressSection(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <div id={`DefaultAddressItem--${props.defaultAddressType.name}`}>
      <span className={classes.defaultAddressSection}>
        <img className={classes.defaultAddressIcon} src={props.defaultAddressType.icon} alt="" />
        <p className={classes.defaultAddressText}>{Translation.getText(props.defaultAddressType.translationKey)}</p>
      </span>
    </div>
  );
}

const DefaultAddressTypePropType = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  translationKey: PropTypes.string,
};

DefaultAddressSection.propTypes = {
  defaultAddressType: PropTypes.shape(DefaultAddressTypePropType).isRequired,
};

export default DefaultAddressSection;
